import { render } from "./CashierDialog.vue?vue&type=template&id=572996f8"
import script from "./CashierDialog.vue?vue&type=script&lang=js"
export * from "./CashierDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__